<template>
<div class="chapter">
<div class="inner_page">
<div class="box3">
<p class="half"><a id="page_3"><em class="italic">Song of Trusting the Heart</em></a></p><a id="page_3">
</a></div><a id="page_3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half.vue?5d3b8da8